module.exports = __webpack_public_path__ + "static/media/logo.e320857d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 726
// module chunks = 0